<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 24px;
            margin-left: 3px;
            letter-spacing: 2px;
          "
        >
          移仓交易工具
        </p>
        <p
          style="
            font-size: 15px;
            color: #000000;
            line-height: 20px;
            letter-spacing: 1px;
          "
        >
          支持自动监控价差移仓、分批移仓、算法交易辅助移仓、多账号移仓。
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
            <li class="pli" v-for="(item,index) in leftnav" :key="index">
                <div v-bind:class="[item.active ? class4 : class3]"></div>
                <div v-bind:class="[item.active ? class1 : class5]" @click="show(index)">
                    <div style="width: 45px; height: 40px; float: left"></div>
                    <div class="tagmid">{{item.text}}</div>
                    <div style="width: 30px; height: 40px; float: left"></div>
                </div>
                <div style="width: 9px; height: 7px; float: left;position:absolute;right:1px;bottom:-7px">
                    <img
                        src="../../assets/images/lan-jia.png"
                        style="display: block"
                        v-if="item.active"
                    />
                </div>
            </li>
        </ul>
        <div class="pdf"><a href="https://ftpc.wenhua.com.cn/files/guide/wh7/download/%E7%A7%BB%E4%BB%93%E4%BA%A4%E6%98%93%E5%B7%A5%E5%85%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf" target="_blank">下载移仓交易工具操作手册</a></div>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="leftnav.filter((el)=>{return el.id=='jj'})[0].active">
              <h4 class="head4" id="productcentertwo">一、简介</h4>
              <p class="pproduct">
               期货有到期时间，做长线的投资者需要在交割前将手中的近月合约平掉，同时开远月月份仓位继续持有，即移仓。
              </p>
              <p class="pproduct">
                由于移仓操作涉及到两个合约，传统软件往往将移仓和套利混为一谈，而实际上二者存在着本质区别，wh7软件针对移仓交易的特点，提供了专业的移仓分析图表、移仓统计工具和移仓下单工具，可自动监控移仓时机先平再开，还可以分批移仓、一键多账户移仓。
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='ycpd'})[0].active">
              <h4 class="head4" id="productcentertwo">二、设置移仓配对</h4>
              <p class="pproduct">
                首先，将需要移仓的两个合约构建成移仓配对，如下图。
              </p>
              <p class="pimg"><img src="@/../public/proimg/YCSC-1.jpg" /></p>
              <p class="pproduct">
                配对好的移仓合约可以在【套利】->移仓配对报价列表中查看，如下图。
              </p>
              <p class="pimg"><img src="@/../public/proimg/YCSC-2.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='cjfx'})[0].active">
              <h4 class="head4" id="productcenterthree">
                三、移仓价差分析
              </h4>
              <p class="pproduct">
                移仓的主要目的不是如何快速完成下单操作，而在于捕捉有利的价差，进行高卖低买，平稳的过渡仓位，所以移仓时要格外关注近月远月合约的价差变化。
              </p>
              <p class="pproduct">
                如下图，软件提供带上下影线的移仓价差K线图，根据移仓配对合约的两腿行情自动计算价差和成交手数，辅助用户分析移仓时机。
              </p>
              <p class="pimg"><img src="@/../public/proimg/YCSC-3.jpg" /></p>
              <p class="pproduct">
                鉴于移仓需求的特殊性，软件提供专用移仓统计工具，直观展示各个价差的移仓成交量分布情况，用户可以根据自己的仓位大小制定移仓策略，过滤掉无法成交的价差，判断最佳移仓价差。
              </p>
              <p class="pproduct">
                如下图，可在移仓K线图上任选范围进行移仓统计分析。
              </p>
              <p class="pimg"><img src="@/../public/proimg/YCSC-4.png" /></p>
              <p class="pproduct">
                软件还提供特色移仓量副图，如下图，根据两腿合约在对应时间范围的增仓情况计算绘制移仓量柱状图，直观反映当根k线范围内市场主力移仓的轨迹。
              </p>
              <p class="pimg"><img src="@/../public/proimg/YCSC-5.jpg" /></p>
              <!-- <p class="pproduct">原理：</p>
              <p class="pproduct">旧合约与新合约的增仓方向相同时，移仓量为0；旧合约与新合约的增仓方向不同时，移仓量正负与新合约增仓方向一致，移仓量值为两腿合约中增仓量绝对值的最小值。</p> -->
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='ycxd'})[0].active">
              <h4 class="head4" id="productcenterfour">四、多账号一键移仓下单</h4>
              <p class="pproduct">
                如下图，是移仓专用下单界面（【套利】->移仓下单），添加移仓下单任务后，软件自动监控移仓配对的价差变化，当价差符合条件时自动先平仓再开仓，抓住移仓时机。还支持分批次下单和多种算法辅助撤单/追价选项，降低移仓成本。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/YCSC-6.jpg')"></BaseBigimg>
              <p class="pproduct">注：</p>
              <p class="pproduct">1、移仓下单任务默认以对价差判断是否满足触发条件；</p>
              <p class="pproduct">2、移仓交易先平旧合约，旧合约平仓成交后立即发出新合约开仓委托；</p>
              <p class="pproduct">3、启用算法交易辅助后，软件自动按所选算法进行判断和撤单/追价；若平仓撤单，则重新判断价差，满足价差时继续委托；</p>
              <p class="pproduct">
                当有多个账号都需要移仓时，可将多个交易账号设置为“交易组”，对组一键移仓下单，如下图，移仓委托、任务可合并显示，像操作单个账号一样简单。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/YCSC-7.jpg')"></BaseBigimg>
              <p class="pproduct">
                如下图，是如何设置多账号组的操作方法，点击软件右下角【期货户】，登录多账号后，按下图所示步骤操作即可。
              </p>
              <p class="pimg"><img src="@/../public/proimg/YCSC-8.png" /></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftnav:[
      {active:true,text:'简介',id:'jj'},
      {active:false,text:'设置移仓配对',id:'ycpd'},
      {active:false,text:'移仓价差分析',id:'cjfx'},
      {active:false,text:'多账号一键移仓下单',id:'ycxd'}],
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    show(index){
        console.log()
        this.leftnav.forEach((el,idx)=>{
            el.active=false
        })
        this.leftnav[index].active=true
    },
   
  },
  created(){
  }

};
</script>

<style scoped>
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 90px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 308px;
  border-radius: 2%;
  background: url("../../assets/images/ts-4_01.png") no-repeat center;
  /* background-size: 100% 100%; */
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
  z-index: 999;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #97c9d9;
  letter-spacing: 1px;
  color: #26353a;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #26353a;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #245376;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #e3a200;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #97c9d9;
  color: #26353a;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.pli:last-child .noclickone{
  border-bottom: 1px solid #97c9d9;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #c2edfb;
}
.noclickele:hover {
  color: #c2edfb;
}
.tagmid {
  width: 152px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.pdf {
    margin-top:60px ;
    height: 90px;
    width: 220px;
    text-align: center;
    line-height: 90px;
}
.pdf a{
  color: #5050cc;
  text-decoration: none;
  font-size: 14px;
}
.pdf a:hover{
  text-decoration:underline;
}
.pdf a:visited{
  color: #5050cc;
}
</style>